import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'atoms/Typography/Typography';
import ActionsWithReviews from 'src/app/molecules/ActionsWithReviews/ActionsWithReviews';
import HeadingAndSupportingText from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingText';

const HeroTextBlock = (): JSX.Element => (
  <Grid
    padding={['spacing-none', 'spacing-4xl']}
    paddingSm={['spacing-none', 'spacing-xl']}
    dataCy='hero-text-block'
  >
    <Stack
      direction='column'
      columns={7}
      columnsXl={9}
      columnsLg={11}
      columnsMd={12}
      gap='spacing-6xl'
      gapSm='spacing-4xl'
    >
      <HeadingAndSupportingText
        heading={{
          type: 'heading',
          size: '2xl',
          children: (
            <Typography as='span'>
              Build a community people <i>love</i>
            </Typography>
          ),
        }}
        supportingText={{
          type: 'paragraph',
          size: 'xl',
          text: 'Your business deserves an unfair advantage—the platform and strategy that helped creators and entrepreneurs earn $500M in 2025.',
          color: 'text-tertiary',
        }}
      />
      <ActionsWithReviews />
    </Stack>
  </Grid>
);

export default HeroTextBlock;
